<template>
  <cTable
    :fields="fields"
    :header="header"
    :config="config"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  ></cTable>
</template>

<script>
import {
  recalculate,
  sync,
  getOtherFee,
  del,
  add,
  getWherehouse,
  getDetails,
  update,
  uploadFile,
  getConfig,
  getFinance,
  saveFinance,
  getCharging,
  createBill,
} from "@/api/finance/vatFee";
import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";
import { getExpense } from "@/api/finance/expense";
import { getService } from "@/api/double/list";
import { getCurrency } from "@/api/finance/currency";
import { getUser } from "@/api/user/internal";
import { getSelectType } from "@/api/public";
import { getCountry } from "@/api/system/country";
export default {
  name: "vatFee",
  components: {
    cTable,
  },
  async mounted() {
    let client = (await getAllClient()).data.payload.rows;
    let expense_item = (await getExpense()).data.payload.rows;
    this.defaultConfig = (await getConfig()).data.payload;
    this.defaultConfig.warehouse = this.defaultConfig.warehouse.map((t) => ({
      value: t.id,
      label: t.title,
    }));
    this.defaultConfig.transLocation = this.defaultConfig.transLocation.map(
      (t) => ({ value: t, label: t })
    );
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "expense_item_id") item.options = expense_item;
      if (item.key === "creator_id") item.options = this.defaultConfig.creator;
      if (item.key === "salesman_id") item.options = salesman;
      if (item.key === "to_country") item.options = toCountry;
    });
  },
  data() {
    return {
      defaultConfig: {},
      methods: {
        list: getOtherFee,
        del,
        getAllClient,
        getExpense,
        getWherehouse,
        add,
        getDetails,
        update,
        uploadFile,
        getFinance,
        saveFinance,
        getCharging,
        createBill,
        recalculate,
        sync,
      },
      config: {
        contentMethod({ row, column }) {
          if (column.type == "calculate_status" && row.calculate_msg) {
            return row.calculate_msg;
          }
        },
      },
      modals: {
        createBill: {
          type: "add",
          methods: {
            ok: ({ row, close }) => {
              let data = JSON.parse(JSON.stringify(row));
              let table = this.$refs["table"];
              data.ids = table.selectAll.map((item) => item.id);
              table
                .handleRequestMethods("createBill", data, true, true)
                .then((res) => {
                  table.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 30,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("SettlementObject"),
              key: "target_type",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("SettlementObject"),
              clearable: false,
              options: [
                { label: this.$t("b2bClient"), value: 1 },
                { label: this.$t("branchOffice"), value: 2 },
              ],
              default: 1,
            },
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: this.$t("whether") + this.$t("show") + "SKU",
              key: "show_sku",
              component: "Radio",
              placeholder: () =>
                this.$t("select") +
                this.$t("whether") +
                this.$t("show") +
                "SKU",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 },
              ],
              default: 0,
              bind: {
                border: true,
              },
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        upload: {
          methods: {
            ok() {
              window.open(
                this.$globalUrl +
                  "/excel/tmp/MiscellaneousDetailsTpl.xlsx?" +
                  Math.random()
              );
            },
          },
          footer: {
            cancel: {
              isShow: true,
            },
            ok: {
              name: this.$t("download_tem"),
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false,
            },
            rowBind: {
              gutter: 16,
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files"),
          },
          grid: [
            {
              files: 24,
            },
          ],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("uploadFile", formData)
                    .then((res) => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                },
              },
            },
          ],
        },
        freight: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              this.$page
                .handleRequestMethods("saveFinance", data, true, true)
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            show() {
              return this.params.bill_id <= 0;
            },
          },
          config: {
            title: this.$t("bindFreight"),
            modalBind: {
              width: 800,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              charges_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              price: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              currency: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            {
              expense_item_name: 24,
              charges_value: 24,
              charges_unit: 24,
              actual_weight: 24,
              volume: 24,
              price: 24,
              charges_type: 24,
              total_amount: 24,
              currency: 24,
              finance_time: 24,
              charge_status: 24,
            },
          ],
          fields: [
            {
              name: this.$t("WhetherBilling"),
              key: "charge_status",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 },
              ],
              default: 1,
              bind: {
                border: true,
              },
            },
            {
              name: this.$t("Confirm Freight"),
              key: "finance_time",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: "YES" },
                { label: this.$t("NO"), value: "NO" },
              ],
              default: "NO",
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("Expense Item"),
              key: "expense_item_name",
              component: "Input",
              placeholder: () => "",
              disabled: true,
            },
            {
              name: () => this.$t("Number Charges"),
              key: "charges_value",
              component: "Input",
              placeholder: () => "",
              disabled: true,
            },
            {
              name: () => this.$t("Charges Unit"),
              key: "charges_unit",
              component: "Input",
              placeholder: () => "",
              disabled: true,
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "actual_weight",
              component: "Input",
              placeholder: () => "",
              disabled: true,
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "Input",
              placeholder: () => "",
              disabled: true,
            },
            {
              name: () => this.$t("Charge Mode"),
              key: "charges_type",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("Charge Mode"),
              options: [],
              methods: {
                "on-change"({ row }) {
                  row.price &&
                    row.charges_type &&
                    this.$page
                      .handleRequestMethods("getCharging", {
                        price: row.price,
                        charges_type: row.charges_type,
                        id: row.id,
                      })
                      .then((res) => {
                        row.total_amount = res.payload;
                      });
                },
                list({ field }) {
                  field.options = this.$modal.params.charge_type_options;
                },
              },
            },
            {
              name: () => this.$t("billing_price"),
              key: "price",
              component: "InputNumber",
              bind: {
                style: "width:100%",
                parser: (value) => (value ? parseFloat(value).toFixed(2) : 0),
              },
              placeholder: () => this.$t("enter") + this.$t("billing_price"),
              default: 0,
              methods: {
                "on-blur"({ row }) {
                  row.price &&
                    row.charges_type &&
                    this.$page
                      .handleRequestMethods("getCharging", {
                        price: row.price,
                        charges_type: row.charges_type,
                        id: row.id,
                      })
                      .then((res) => {
                        row.total_amount = res.payload;
                      });
                },
              },
            },
            {
              name: () => this.$t("Charge Total Amount"),
              key: "total_amount",
              component: "Input",
              placeholder: () => this.$t("Charge Total Amount"),
              disabled: true,
            },
            {
              name: this.$t("toCurrency"),
              key: "currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "title",
                value: "code",
              },
              methods: {
                list({ field }) {
                  getCurrency().then((res) => {
                    if (res.data.status) {
                      field.options = res.data.payload.rows;
                    }
                  });
                },
              },
            },
          ],
        },
        add: {
          footer: {
            show() {
              return ~~this.params.bill_id <= 0;
            },
          },
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 1200,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_id: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              expense_item_id: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              charges_value: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              charges_unit: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [
            {
              client_id: 6,
              expense_item_id: 6,
              charges_value: 6,
              charges_unit: 6,
              numbers: 6,
              batch_no: 6,
              actual_weight: 6,
              volume: 6,
              warehouse: 6,
            },
            {
              name: this.$t("Storage Charges"),
              children: [
                {
                  in_time: 8,
                  send_time: 8,
                  service_code: 8,
                },
              ],
            },
            {
              name: this.$t("TransferFee"),
              children: [
                {
                  trans_time: 8,
                  trans_location: 8,
                },
              ],
            },
            {
              remarks: 24,
            },
          ],
          fields: [
            {
              name: () => this.$t("Number Charges"),
              key: "charges_value",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Number Charges"),
            },
            {
              name: () => this.$t("Charges Unit"),
              key: "charges_unit",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("Charges Unit"),
              methods: {
                list: ({ field }) => {
                  field.options = this.defaultConfig.unit;
                },
              },
            },
            {
              name: () => this.$t("batch_number"),
              key: "batch_no",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("batch_number"),
            },
            {
              name: () => this.$t("inboundTime"),
              key: "in_time",
              placeholder: () => this.$t("enter") + this.$t("inboundTime"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
              methods: {
                format({ value }) {
                  return ~~(new Date(value).getTime() / 1e3);
                },
              },
            },
            {
              name: () => this.$t("Delivery Time"),
              key: "send_time",
              placeholder: () => this.$t("enter") + this.$t("Delivery Time"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
              methods: {
                format({ value }) {
                  return ~~(new Date(value).getTime() / 1e3);
                },
              },
            },
            {
              name: () => this.$t("Transit Time"),
              key: "trans_time",
              placeholder: () => this.$t("enter") + this.$t("Transit Time"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
              methods: {
                format({ value }) {
                  return ~~(new Date(value).getTime() / 1e3);
                },
              },
            },
            {
              name: () => this.$t("Delivery Type"),
              key: "service_code",
              placeholder() {
                return this.$t("select") + this.$t("Delivery Type");
              },
              component: "Select",
              options: [],
              config: {
                label: "service_name",
                value: "service_code",
              },
              methods: {
                async list({ field }) {
                  let res = (await getService()).data.payload;
                  field.options = res;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("warehouse"),
              key: "warehouse",
              component: "Select",
              placeholder: () => this.$t("enter") + this.$t("warehouse"),
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.defaultConfig.warehouse;
                },
              },
            },
            {
              name: () => this.$t("Transit Destination"),
              key: "trans_location",
              component: "Select",
              placeholder: () =>
                this.$t("enter") + this.$t("Transit Destination"),
              bind: {
                "allow-create": true,
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.defaultConfig.transLocation;
                },
              },
            },
            {
              name: () => this.$t("clientName"),
              key: "client_id",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("clientName"),
              config: {
                label: "account",
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (await getAllClient()).data.payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("Expense Item"),
              key: "expense_item_id",
              component: "Select",
              placeholder: () => this.$t("Expense Item"),
              config: {
                label: "name",
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (await getExpense()).data.payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("tracking order"),
              key: "numbers",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("tracking order"),
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "actual_weight",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("invoiceWeight"),
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("square"),
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("payment_description"),
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
      },
      footer: {
        show: () => true,
      },
      header: {
        searchs: [
          // {
          //   key: "dateType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   clearable: false,
          //   component: "Select",
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getSelectType(["MISCELLANEOUS_DATETYPE"])).data
          //         .payload["MISCELLANEOUS_DATETYPE"];
          //       field.options = res;
          //       searchForm[field.key] = res[0].value;
          //       this.$forceUpdate();
          //     },
          //   },
          // },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              "default-time": "23:59:59",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("billingStatus");
            },
            clearable: true,
            options: [
              { label: this.$t("billFailed"), value: 0 },
              {
                label: this.$t("billSuccess"),
                value: 1,
              },
            ],
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "finance_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("cod_status");
            },
            clearable: true,
            options: [
              { label: this.$t("noOrder"), value: 0 },
              { label: this.$t("isOrder"), value: 1 },
              { label: this.$t("objection"), value: 3 },
              { label: this.$t("Settled"), value: 9 },
            ],
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 2,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 1261,
            },
            {
              name: () => this.$t("batch") + this.$t("delete"),
              type: "delete",
              fnName: "batchDelete",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-trash",
              },
              id: 1260,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("import"),
              type: "import",
              fnName: "import",
              bind: {
                type: "primary",
              },
              id: 1421,
            },
            {
              name: () => this.$t("createBill"),
              type: "createBill",
              fnName: "createBill",
              bind: {
                icon: "md-add",
                type: "warning",
              },
            },
            {
              name: this.$t("resAmount"),
              type: "resAmount",
              fnName: "resAmount",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$t("synchronous"),
              type: "sync",
              fnName: "sync",
              bind: {
                // icon: "md-checkmark",
                type: "primary",
              },
            },
          ],
          methods: {
            sync() {
              this.handleRequestMethods("sync").then((res) => {
                this.getList();
              });
            },
            resAmount({ row }) {
              const data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("resAmount"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("recalculate", data).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
            createBill({ searchForm }) {
              this.getModal("createBill").open(searchForm);
            },
            import() {
              this.getModal("upload").open();
            },
            async export({ searchForm }) {
              let res = await this.handleRequestMethods(
                "list",
                { ...searchForm, page: 1, export: 1 },
                false,
                true
              );
              window.open(this.$globalUrl + res.payload);
            },
            add() {
              this.getModal("add").open();
            },
            batchDelete() {
              const data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("batch") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", data, true, true).then(
                    () => {
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("waybillNumber"),
          key: "airway_bill_number",
          minWidth: 110,
          fixed: "left",
        },
        {
          name: () => this.$t("clientName"),
          key: "clientInfo.client_account",
          minWidth: 110,
        },
        {
          name: () => this.$t("customerCompanyName"),
          key: "clientInfo.salesman_account",
          minWidth: 110,
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          minWidth: 110,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          minWidth: 110,
        },
        {
          name: () => this.$t("tracker_code"),
          key: "shipment.trace_code",
          minWidth: 110,
        },
        {
          name: () => this.$t("tracker_time"),
          key: "shipment.trace_time",
          minWidth: 110,
        },
        {
          name: () => this.$t("track_title"),
          key: "shipment.trace_remarks",
          minWidth: 110,
        },
        {
          name: () => this.$t("skuAmount") + " USD",
          key: "shipment.values",
          minWidth: 110,
        },
        {
          name: () => this.$t("OriginalDeclaredValue") + " SAR",
          key: "extraValues",
          minWidth: 110,
        },
        {
          name: () => this.$t("clearagent"),
          key: "delivery_agent_name",
          minWidth: 110,
        },
        {
          name: () => this.$t("clearance_done_date"),
          key: "tax_time",
          minWidth: 110,
        },
        {
          name: () => this.$t("totalFee"),
          key: "to_total_amount",
          minWidth: 110,
        },
        {
          name: () => this.$t("currency_t"),
          key: "to_currency",
          minWidth: 110,
        },
        {
          name: () => this.$t("SettlementStatus"),
          key: "finance_status_txt",
          minWidth: 110,
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          minWidth: 110,
          // component: "a",
          // methods: {
          // 	click({ row }) {
          // 		this.$page.toPage("other_fee_bill",row.bill_number)
          // 	},
          // },
        },
        {
          name: () => this.$t("exlType"),
          key: "calculate_status_txt",
          type: "calculate_status",
          minWidth: 80,
          noDeep: true,
          fixed: "right",
          bind: {
            style({ row }) {
              return {
                color: row.calculate_status == 1 ? "#4caf50" : "#f44336",
              };
            },
          },
          methods: {
            render: ({ row }) => {
              return row.calculate_status == 1
                ? this.$t("billSuccess")
                : this.$t("billFailed");
            },
          },
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 1262,
            },
            {
              name: this.$t("bindFreight"),
              type: "freight",
              fnName: "freight",
              bind: {
                type: "success",
              },
              afterIcon({ row }) {
                return row.finance_time ? "md-checkbox" : "ios-square";
              },
              id: 1420,
            },
          ],
          methods: {
            freight({ row }) {
              this.handleRequestMethods("getFinance", row.id).then((res) => {
                this.getModal("freight").open(
                  {
                    ...res.payload.info,
                    charge_type_options: res.payload.charge_type,
                  },
                  function () {
                    this.config.formBind.disabled =
                      res.payload.info.bill_id > 0;
                    this.setTitle(this.$t("bindFreight"));
                  }
                );
              });
            },
            update({ row }) {
              console.log(row.id);
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                if (!res.payload.ship_time) res.payload.ship_time = "";
                else
                  res.payload.ship_time = new Date(
                    res.payload.ship_time * 1000
                  );
                this.getModal("add").open(res.payload, function () {
                  this.config.formBind.disabled = res.payload.bill_id > 0;
                  this.setTitle(this.$t("update"));
                });
              });
            },
          },
        },
      ],
    };
  },
};
</script>
